import React, { useEffect } from 'react'
import { ModalService } from 'services/ModalService'
import { ForgotPassword, WithClearSafariPageCache } from '@it25syv/25syv-ui'
import NotificationConductor from 'common/conductors/NotificationConductor'
import UserAdapter from 'common/adapters/UserAdapter'
import UrlHistoryService from 'services/UrlHistoryService'
import selfExclusionNotification from 'features/SelfExclusion/SelfExludedNotification'
import { useHistory } from 'react-router-dom'
import UserService from 'services/UserService'
import productIcon from 'images/casino-forgot-pass.png'
import { COLORS } from 'themes'

const PinLoginForgotPass = ({ data }) => {
    return (
        <ForgotPassword
            closeAction={() => {
                ModalService.closeModal()
            }}
            productIcon={productIcon}
            theme={'dark'}
            primaryColor={COLORS.primary}
            oldAPI={true}
            isPinLogin={true}
            beforeLogin={() => {
                UserService.removePinLoginData()
            }}
        />
    )
}

export default WithClearSafariPageCache(PinLoginForgotPass)
